import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import GroupLogo from '../../GroupLogo/GroupLogo';

import './MobileModalTrigger.scss';
import { GroupContext, PageContext } from '../../../../contexts/ContextCreator';
import { LOGIN_LAYOUT } from '../../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';

const MobileModalTrigger = (props) => {
    const { wrapAuth, isLoggedIn } = useContext(PageContext);
    const groupContext = useContext(GroupContext);
    const { modalTrigger } = props;

    const modalData = {
        groupContext,
        ...props,
    };

    return (
        <div className="component-Groups-Modals-MobileModalTrigger">
            {wrapAuth(
                'GroupsMobileMenu',
                <button
                    type="button"
                    onClick={() =>
                        isLoggedIn() ? modalTrigger(modalData) : null
                    }
                >
                    <div className="background-svg">
                        <div className="group-logo-container">
                            <GroupLogo
                                logo={groupContext?.group?.logo}
                                name={groupContext?.group?.name}
                                isAdmin={false}
                                iconSize="xSmall"
                                className="modal-trigger-logo"
                            />
                        </div>
                    </div>
                </button>,
                {
                    login_trigger: 'groups-mobile-menu-click',
                },
                null,
                LOGIN_LAYOUT
            )}
        </div>
    );
};

MobileModalTrigger.propTypes = {
    modalTrigger: PropTypes.func.isRequired,
};

export default React.memo(MobileModalTrigger);
